.priority-cell {
  display: flex;
  justify-content: center;
}

gz-icon.disabled {
  opacity: 0.34;
  pointer-events: none;
}

.reordering-footer gz-button {
  padding-left: 40px; // the size of the reorder cell
}

.reset-priority-footer {
  right: 0;
  left: unset;
  height: calc(var(--spacer) * 5);

  gz-button {
    margin-top: var(--spacer);
    padding: var(--spacer) calc(var(--spacer) * 2);
  }
}

:host([resetPriorityButtonRendered]) {
  --footer-border-bottom: none;
  --footer-height: calc(var(--spacer) * 5);
}
